{
  "invoices": {
    "header": {
      "title": "Facturen",
      "title_reimbursement": "Terugbetalingen",
      "description": "Facturen die voor deze organisatie zijn gegenereerd.",
      "description_reimbursement": "Terugbetalingen die voor deze organisatie zijn gegenereerd."
    },
    "datasets": {
      "aria": "Kies welke administratie wordt getoond",
      "billing": "Facturatie",
      "reimbursement": "Terugbetaling"
    },
    "role": {
      "loading": "Je toegangsniveau wordt geladen…",
      "error": {
        "title": "Kon je toegangsniveau niet laden",
        "description": "Het laden van je accountgegevens is mislukt. Probeer het opnieuw."
      }
    },
    "noAccess": {
      "title": "Geen toegang tot facturen",
      "description": "Je account heeft geen toegang tot de facturenmodule. Neem contact op met een beheerder als je denkt dat je die zou moeten hebben."
    },
    "organisations": {
      "title": "Organisaties binnen deze tenant",
      "loading": "Organisaties worden geladen…",
      "columns": {
        "organisation": "Organisatie",
        "description": "Omschrijving",
        "type": "Type",
        "id": "ID"
      },
      "types": {
        "tenant": "Tenantorganisatie",
        "domain": "Domeinorganisatie"
      },
      "empty": {
        "title": "Geen organisaties",
        "description": "Deze tenant heeft geen organisaties."
      },
      "error": {
        "title": "Kon organisaties niet laden",
        "description": "Het laden van de organisaties van de tenant is mislukt. Probeer het opnieuw."
      }
    },
    "list": {
      "title": "Facturen",
      "title_reimbursement": "Terugbetalingen",
      "titleLatest": "Nieuwste facturen",
      "titleLatest_reimbursement": "Nieuwste terugbetalingen",
      "count": "{{count}} factuur",
      "count_reimbursement": "{{count}} terugbetaling",
      "count_other": "{{count}} facturen",
      "count_reimbursement_other": "{{count}} terugbetalingen",
      "searchPlaceholder": "Zoek op factuurnummer, klant of referentie",
      "searchPlaceholder_reimbursement": "Zoek op terugbetalingsnummer, klant of referentie",
      "searchAria": "Zoek facturen",
      "searchAria_reimbursement": "Zoek terugbetalingen",
      "loading": "Facturen worden geladen…",
      "loading_reimbursement": "Terugbetalingen worden geladen…",
      "columns": {
        "invoice": "Factuur",
        "invoice_reimbursement": "Terugbetaling",
        "client": "Klant",
        "assignedTo": "Gekoppeld aan",
        "date": "Datum",
        "status": "Status",
        "amount": "Bedrag"
      },
      "toasts": {
        "downloadFailed": "Kon de factuur niet downloaden. Probeer het opnieuw.",
        "downloadFailed_reimbursement": "Kon de terugbetaling niet downloaden. Probeer het opnieuw."
      },
      "status": {
        "concept": "Concept",
        "sent": "Verzonden",
        "partlyPaid": "Deels betaald",
        "paid": "Betaald",
        "credit": "Credit",
        "cancelled": "Geannuleerd",
        "unknown": "Status {{status}}"
      },
      "filters": {
        "aria": "Facturen filteren",
        "status": "Status",
        "month": "Maand",
        "monthAria": "Filter op maand",
        "allMonths": "Alle maanden",
        "clear": "Filters wissen"
      },
      "empty": {
        "title": "Geen facturen",
        "title_reimbursement": "Geen terugbetalingen",
        "description": "Er zijn geen facturen zichtbaar voor je account. Facturen verschijnen zodra je klanten gekoppeld en gefactureerd zijn.",
        "description_reimbursement": "Er zijn geen terugbetalingen zichtbaar voor je account. Ze verschijnen zodra je klanten gekoppeld zijn en er een terugbetaling is aangemaakt."
      },
      "noResults": {
        "title": "Geen resultaten",
        "description": "Niets komt overeen met de huidige zoekopdracht en filters. Probeer een andere term of wis de filters."
      },
      "error": {
        "title": "Kon facturen niet laden",
        "title_reimbursement": "Kon terugbetalingen niet laden",
        "description": "Het laden van de facturen uit het facturatiesysteem is mislukt. Probeer het opnieuw.",
        "description_reimbursement": "Het laden van de terugbetalingen uit het facturatiesysteem is mislukt. Probeer het opnieuw."
      }
    },
    "detail": {
      "eyebrow": "Factuur",
      "eyebrow_reimbursement": "Terugbetaling",
      "loading": "Factuurgegevens worden geladen…",
      "loading_reimbursement": "Gegevens van de terugbetaling worden geladen…",
      "close": "Sluiten",
      "download": "Factuur downloaden",
      "download_reimbursement": "Terugbetaling downloaden",
      "outstanding": "{{amount}} openstaand",
      "invoiceTotal": "Factuurtotaal",
      "invoiceTotal_reimbursement": "Totaal terugbetaling",
      "error": {
        "title": "Kon de factuur niet laden",
        "title_reimbursement": "Kon de terugbetaling niet laden",
        "description": "Het laden van de factuurgegevens uit het facturatiesysteem is mislukt. Probeer het opnieuw.",
        "description_reimbursement": "Het laden van de gegevens van de terugbetaling uit het facturatiesysteem is mislukt. Probeer het opnieuw."
      },
      "sections": {
        "details": "Factuurgegevens",
        "details_reimbursement": "Gegevens terugbetaling",
        "amounts": "Bedragen",
        "description": "Omschrijving",
        "lines": "Regels",
        "attachments": "Bijlagen"
      },
      "attachments": {
        "download": "Downloaden",
        "failed": "Kon {{name}} niet downloaden. Probeer het opnieuw."
      },
      "fields": {
        "code": "Factuurnummer",
        "code_reimbursement": "Nummer terugbetaling",
        "client": "Klant",
        "clientReference": "Klantreferentie",
        "clientEmail": "E-mailadres",
        "assignedTo": "Gekoppeld aan",
        "date": "Factuurdatum",
        "date_reimbursement": "Datum terugbetaling",
        "dueDate": "Vervaldatum",
        "sentDate": "Verzonden op",
        "paidDate": "Betaald op",
        "paymentMethod": "Betaalmethode",
        "reference": "Referentie",
        "modified": "Laatst gewijzigd"
      },
      "amounts": {
        "excl": "Subtotaal (excl. btw)",
        "tax": "Btw",
        "incl": "Totaal (incl. btw)",
        "paid": "Betaald",
        "outstanding": "Openstaand"
      },
      "lines": {
        "columns": {
          "description": "Omschrijving",
          "quantity": "Aantal",
          "priceExcl": "Stukprijs",
          "tax": "Btw"
        },
        "quantity": "{{quantity}} {{unit}}",
        "tax": "{{percentage}}%"
      }
    },
    "clients": {
      "title": "Factuurklanten",
      "title_reimbursement": "Terugbetalingsklanten",
      "count": "{{count}} klant",
      "count_other": "{{count}} klanten",
      "searchPlaceholder": "Zoek op klant, e-mail, referentie of plaats",
      "searchAria": "Zoek factuurklanten",
      "searchAria_reimbursement": "Zoek terugbetalingsklanten",
      "loading": "Factuurklanten worden geladen…",
      "loading_reimbursement": "Terugbetalingsklanten worden geladen…",
      "notLinked": "Niet gekoppeld",
      "kinds": {
        "tenant": "Tenant",
        "organisation": "Organisatie"
      },
      "columns": {
        "client": "Klant",
        "reference": "Referentie",
        "linkedTo": "Gekoppeld aan",
        "combineInvoices": "Facturen samenvoegen",
        "actions": "Acties"
      },
      "combineInvoices": {
        "combined": "Samengevoegd"
      },
      "actions": {
        "add": "Nieuwe klant",
        "link": "Koppelingen beheren"
      },
      "empty": {
        "title": "Geen klanten",
        "description": "Geen klanten voldoen aan de huidige zoekopdracht."
      },
      "error": {
        "title": "Kon factuurklanten niet laden",
        "title_reimbursement": "Kon terugbetalingsklanten niet laden",
        "description": "Het laden van de klanten uit het facturatiesysteem is mislukt. Probeer het opnieuw."
      },
      "dialog": {
        "title": "Koppelingen beheren",
        "description": "Koppel {{name}} aan de tenants of organisaties waar de facturen bij horen.",
        "description_reimbursement": "Koppel {{name}} aan de tenants of organisaties waar de terugbetalingen bij horen.",
        "fields": {
          "tenant": "Tenant",
          "tenantPlaceholder": "Selecteer een tenant…",
          "organisation": "Organisatie"
        },
        "wholeTenant": "Hele tenant",
        "organisationHint": "Laat op “Hele tenant” staan om de hele tenant te koppelen, of kies één organisatie erbinnen.",
        "errors": {
          "tenant": "Selecteer een tenant.",
          "alreadyLinked": "Deze klant is al aan dat doel gekoppeld."
        },
        "currentLinks": "Gekoppeld aan",
        "noLinks": "Nog niet aan een tenant of organisatie gekoppeld — de facturen worden aan niemand toegeschreven.",
        "noLinks_reimbursement": "Nog niet aan een tenant of organisatie gekoppeld — de terugbetalingen worden aan niemand toegeschreven.",
        "addLink": "Koppeling toevoegen",
        "add": "Koppeling toevoegen",
        "close": "Sluiten",
        "removeLink": "Koppeling met {{name}} verwijderen"
      },
      "details": {
        "title": "Klantgegevens",
        "loading": "Klantgegevens worden geladen…",
        "close": "Sluiten",
        "edit": "Klant bewerken",
        "error": {
          "title": "Kon klantgegevens niet laden",
          "description": "Het laden van de klantgegevens uit het facturatiesysteem is mislukt. Probeer het opnieuw."
        },
        "fields": {
          "companyName": "Bedrijf",
          "debtorCode": "Debiteurnummer",
          "companyNumber": "KvK-nummer",
          "taxNumber": "Btw-nummer",
          "contactName": "Contactpersoon",
          "email": "E-mail",
          "phoneNumber": "Telefoon",
          "mobileNumber": "Mobiel",
          "address": "Adres",
          "zipCode": "Postcode",
          "city": "Plaats",
          "country": "Land",
          "iban": "IBAN",
          "bic": "BIC",
          "accountName": "Rekeninghouder",
          "bank": "Bank",
          "currency": "Valuta",
          "comment": "Opmerking",
          "modified": "Laatst gewijzigd",
          "linkedTo": "Gekoppeld aan",
          "houseStyle": "Huisstijl",
          "combineInvoices": "Facturen samenvoegen"
        },
        "combineInvoices": {
          "yes": "Ja, één samengevoegde factuur",
          "no": "Nee, losse facturen"
        }
      },
      "form": {
        "addTitle": "Nieuwe klant",
        "editTitle": "Klant bewerken",
        "description": "Klantgegevens zoals het facturatiesysteem ze bijhoudt. Wijzigingen worden daar direct opgeslagen.",
        "nameHint": "Vul een bedrijfsnaam, een achternaam of beide in - het facturatiesysteem heeft er minstens één nodig.",
        "debtorCodePlaceholder": "Wordt automatisch toegekend (CMX-...)",
        "addDescription": "De nieuwe klant wordt aangemaakt in zowel Facturatie als Terugbetaling, onder één klantcode. Latere wijzigingen worden per administratie opgeslagen.",
        "countryPlaceholder": "bijv. NL",
        "currencyPlaceholder": "bijv. EUR",
        "houseStyleHint": "De opmaak en taal waarin het facturatiesysteem de facturen van deze klant verstuurt.",
        "combineInvoicesHint": "Alle facturen van deze klant worden samengevoegd tot één factuur. Dit geldt voor de klant als geheel, niet per verdeelafspraak.",
        "sections": {
          "company": "Bedrijf",
          "contact": "Contactpersoon",
          "address": "Adres",
          "billing": "Bankgegevens",
          "invoicing": "Facturatie"
        },
        "sex": {
          "unspecified": "Niet opgegeven",
          "m": "Dhr.",
          "f": "Mevr.",
          "d": "Mx.",
          "fam": "Familie",
          "u": "Onbekend"
        },
        "fields": {
          "companyName": "Bedrijf",
          "debtorCode": "Debiteurnummer",
          "companyNumber": "KvK-nummer",
          "taxNumber": "Btw-nummer",
          "sex": "Aanhef",
          "initials": "Initialen",
          "surName": "Achternaam",
          "email": "E-mail",
          "phoneNumber": "Telefoon",
          "mobileNumber": "Mobiel",
          "address": "Adres",
          "zipCode": "Postcode",
          "city": "Plaats",
          "country": "Land",
          "iban": "IBAN",
          "bic": "BIC",
          "accountName": "Rekeninghouder",
          "bank": "Bank",
          "currency": "Valuta",
          "comment": "Opmerking",
          "houseStyle": "Huisstijl",
          "combineInvoices": "Alle facturen samenvoegen tot één factuur"
        },
        "errors": {
          "name": "Vul een bedrijfsnaam of een achternaam in.",
          "email": "Vul een geldig e-mailadres in.",
          "saveFailed": "Kon de klant niet opslaan. Probeer het opnieuw."
        },
        "cancel": "Annuleren",
        "create": "Klant aanmaken",
        "save": "Wijzigingen opslaan"
      },
      "toasts": {
        "linked": "{{name}} gekoppeld.",
        "unlinked": "Koppeling met {{name}} verwijderd.",
        "created": "Klant {{name}} aangemaakt.",
        "updated": "Klant {{name}} bijgewerkt.",
        "saveFailed": "Kon de koppeling niet opslaan. Probeer het opnieuw.",
        "unlinkFailed": "Kon de koppeling niet verwijderen. Probeer het opnieuw."
      },
      "moreLinks": "+{{count}} meer",
      "moreLinks_other": "+{{count}} meer"
    }
  },
  "fees": {
    "header": {
      "title": "Kosten",
      "description": "Wat een klant NRG per laadpunt betaalt, per tenant of organisatie.",
      "description_reimbursement": "Het aandeel van NRG in elk tariefonderdeel aan de terugbetalingskant, per tenant of organisatie."
    },
    "loading": "Toegang laden…",
    "error": {
      "title": "Kon uw toegang niet bepalen",
      "description": "Het laden van uw IAM-bereik is mislukt. Probeer het opnieuw."
    },
    "noAccess": {
      "title": "Alleen domein",
      "description": "Kosten zijn wat NRG verdient, dus alleen domeingebruikers kunnen ze bekijken en beheren."
    },
    "datasets": {
      "aria": "Kies welke administratie wordt getoond",
      "billing": "Facturatie",
      "reimbursement": "Terugbetaling"
    },
    "service": {
      "title": "Servicekosten",
      "count": "{{count}} organisatie",
      "count_other": "{{count}} organisaties",
      "searchPlaceholder": "Zoek op tenant of organisatie",
      "searchAria": "Zoek servicekosten",
      "add": "Servicekosten toevoegen",
      "nothing": "Geen aandeel in enig onderdeel",
      "columns": {
        "target": "Tenant / organisatie",
        "fee": "Servicekosten"
      },
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisatie"
      },
      "actions": {
        "edit": "Servicekosten bewerken",
        "delete": "Servicekosten verwijderen"
      },
      "empty": {
        "title": "Geen servicekosten",
        "description": "Geen enkele tenant of organisatie heeft servicekosten ingesteld. Zonder deze nemen we geen aandeel en is de volledige locatieprijs beschikbaar om te verdelen."
      },
      "error": {
        "title": "Kon servicekosten niet laden",
        "description": "Het laden van de servicekosten is mislukt. Probeer het opnieuw."
      },
      "dialog": {
        "addTitle": "Servicekosten toevoegen",
        "editTitle": "Servicekosten bewerken",
        "description": "Ons aandeel in elk onderdeel van het tarief, dat eraf gaat voordat de rest over de partijen wordt verdeeld. Het geldt voor elke locatie van het doel en wordt hier dus niet tegen één prijs gecontroleerd - dat doet het splitsingsvenster per locatie.",
        "wholeTenant": "Hele tenant",
        "wholeTenantHint": "Laat de organisatie leeg om de kosten voor de hele tenant in te stellen. Kosten op één organisatie gaan voor die van de tenant.",
        "sections": {
          "value": "Aandeel per onderdeel"
        },
        "fields": {
          "target": "Geldt voor",
          "tenant": "Tenant",
          "tenantPlaceholder": "Selecteer een tenant…",
          "organisation": "Organisatie"
        },
        "errors": {
          "tenant": "Selecteer een tenant.",
          "tenantTaken": "Deze tenant heeft al servicekosten. Kies een van de organisaties om ze te overschrijven, of bewerk de kosten van de tenant zelf."
        },
        "cancel": "Annuleren",
        "create": "Servicekosten toevoegen",
        "save": "Wijzigingen opslaan"
      },
      "deleteDialog": {
        "title": "Servicekosten verwijderen",
        "description": "Servicekosten voor {{name}} verwijderen? Wat erop steunde valt terug op de kosten van de tenant, of op helemaal geen aandeel.",
        "confirm": "Servicekosten verwijderen"
      },
      "toasts": {
        "created": "Servicekosten voor {{name}} ingesteld.",
        "updated": "Servicekosten voor {{name}} bijgewerkt.",
        "deleted": "Servicekosten voor {{name}} verwijderd.",
        "saveFailed": "Kon de servicekosten niet opslaan. Probeer het opnieuw.",
        "deleteFailed": "Kon de servicekosten niet verwijderen. Probeer het opnieuw."
      }
    },
    "billing": {
      "title": "Facturatiekosten",
      "count": "{{count}} organisatie",
      "count_other": "{{count}} organisaties",
      "searchPlaceholder": "Zoek op tenant of organisatie",
      "searchAria": "Zoek facturatiekosten",
      "add": "Facturatiekosten toevoegen",
      "nothing": "Geen kosten",
      "perChargingPoint": "{{value}} per laadpunt",
      "columns": {
        "target": "Tenant / organisatie",
        "fee": "Facturatiekosten",
        "chargingPoints": "Laadpunten",
        "total": "Totaal"
      },
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisatie"
      },
      "actions": {
        "edit": "Facturatiekosten bewerken",
        "delete": "Facturatiekosten verwijderen"
      },
      "empty": {
        "title": "Geen facturatiekosten",
        "description": "Geen enkele tenant of organisatie heeft facturatiekosten ingesteld."
      },
      "error": {
        "title": "Kon facturatiekosten niet laden",
        "description": "Het laden van de facturatiekosten is mislukt. Probeer het opnieuw."
      },
      "dialog": {
        "addTitle": "Facturatiekosten toevoegen",
        "editTitle": "Facturatiekosten bewerken",
        "description": "Wat de klant ons per laadpunt betaalt. Het geldt voor elk laadpunt van het doel.",
        "wholeTenant": "Hele tenant",
        "wholeTenantHint": "Laat de organisatie leeg om de kosten voor de hele tenant in te stellen. Kosten op één organisatie gaan voor die van de tenant.",
        "sections": {
          "value": "Kosten"
        },
        "fields": {
          "target": "Geldt voor",
          "tenant": "Tenant",
          "tenantPlaceholder": "Selecteer een tenant…",
          "organisation": "Organisatie",
          "price": "Prijs per laadpunt",
          "priceUnit": "€"
        },
        "errors": {
          "tenant": "Selecteer een tenant.",
          "tenantTaken": "Deze tenant heeft al facturatiekosten. Kies een van de organisaties om ze te overschrijven, of bewerk de kosten van de tenant zelf."
        },
        "cancel": "Annuleren",
        "create": "Facturatiekosten toevoegen",
        "save": "Wijzigingen opslaan"
      },
      "deleteDialog": {
        "title": "Facturatiekosten verwijderen",
        "description": "Facturatiekosten voor {{name}} verwijderen? Wat erop steunde valt terug op de kosten van de tenant, of op helemaal geen kosten.",
        "confirm": "Facturatiekosten verwijderen"
      },
      "toasts": {
        "created": "Facturatiekosten voor {{name}} ingesteld.",
        "updated": "Facturatiekosten voor {{name}} bijgewerkt.",
        "deleted": "Facturatiekosten voor {{name}} verwijderd.",
        "saveFailed": "Kon de facturatiekosten niet opslaan. Probeer het opnieuw.",
        "deleteFailed": "Kon de facturatiekosten niet verwijderen. Probeer het opnieuw."
      }
    }
  },
  "splitBilling": {
    "header": {
      "title": "Verdeelafspraak",
      "description": "Verdeelt de laadinkomsten van een locatie over partijen, die elk hun deel terugbetaald krijgen."
    },
    "splits": {
      "title": "Splitsingen",
      "count": "{{count}} splitsing",
      "count_other": "{{count}} splitsingen",
      "searchPlaceholder": "Zoek op splitsing, partij of referentie",
      "searchAria": "Zoek splitsingen",
      "add": "Splitsing toevoegen",
      "units": {
        "perKwh": "{{value}}/kWh",
        "perHour": "{{value}}/u",
        "perSession": "{{value}}/sessie"
      },
      "components": {
        "energyPricePerKwh": {
          "short": "Energie",
          "unit": "€/kWh"
        },
        "chargingTimePricePerHour": {
          "short": "Laadtijd",
          "unit": "€/u"
        },
        "parkingTimePricePerHour": {
          "short": "Parkeertijd",
          "unit": "€/u"
        },
        "flatFeePrice": {
          "short": "Starttarief",
          "unit": "€/sessie"
        }
      },
      "columns": {
        "name": "Splitsing",
        "location": "Locatie",
        "users": "Partijen"
      },
      "actions": {
        "edit": "Splitsing bewerken",
        "delete": "Splitsing verwijderen"
      },
      "empty": {
        "title": "Geen splitsingen",
        "description": "Geen splitsingen komen overeen met de zoekopdracht. Voeg er een toe om het tarief van een locatie over een of meer partijen te verdelen."
      },
      "error": {
        "title": "Kon splitsingen niet laden",
        "description": "Het laden van de splitsingen is mislukt. Probeer het opnieuw."
      },
      "fileFormats": {
        "Xlsx": "Excel (XLSX)",
        "Csv": "CSV"
      },
      "dialog": {
        "addTitle": "Splitsing toevoegen",
        "editTitle": "Splitsing bewerken",
        "description": "Verdeel elk onderdeel van het tarief van een locatie over de servicekosten en een of meer partijen. De partijen zijn klanten van de vergoedingsadministratie in WeFact, beheerd op de facturenpagina. Alleen de onderdelen die de locatie in rekening brengt worden getoond.",
        "sections": {
          "details": "Splitsingsgegevens",
          "shares": "Partijen"
        },
        "serviceFeeFromTenant": "Deze servicekosten zijn op de tenant ingesteld en gelden voor al haar organisaties.",
        "locationTariff": "Tarief: {{summary}}",
        "fields": {
          "name": "Naam",
          "location": "Locatie",
          "locationPlaceholder": "Selecteer een locatie…",
          "user": "Partij {{index}}",
          "userPlaceholder": "Selecteer een klant…",
          "reference": "Referentie",
          "email": "Factuur-e-mailadres",
          "componentTariff": "Aandeel {{component}} voor partij {{user}}",
          "addUser": "Partij toevoegen",
          "removeUser": "Partij {{index}} verwijderen",
          "attachCdr": "Sessiebestand (CDR) bijvoegen",
          "cdrFileFormat": "Formaat sessiebestand",
          "houseStyle": "Huisstijl"
        },
        "hints": {
          "attachCdr": "Stuur het sessiebestand mee met de factuur van deze partij voor deze verdeelafspraak. Zet dit uit als de partij alleen de bedragen wil."
        },
        "summary": {
          "price": "Tarief",
          "serviceFee": "Servicekosten",
          "remaining": "Resterend"
        },
        "settlement": {
          "note": "Terugbetalingen worden afgehandeld op basis van volgorde. We betalen eerst de eerste partij op de lijst uit en gaan vervolgens verder met de volgende partij, totdat het volledige bedrag is verrekend met de tarieven van het station.",
          "moreInfo": "Hoe de uitbetaling wordt berekend",
          "explanation": "De laatste partij fungeert als de balans: als het tarief hoger is dan het totale verdeelde bedrag, ontvangt hij het overschot; als het lager is, wordt zijn aandeel verlaagd. Eventuele extra kosten voor de oplaadkaart worden ook van zijn aandeel afgetrokken."
        },
        "errors": {
          "locationTaken": "Deze locatie heeft al een active split. Er is slechts één split per locatie toegestaan.",
          "serviceFeeUnavailable": "De servicekosten konden niet worden geladen, waardoor deze splitsing niet tegen de locatieprijs kan worden gecontroleerd. Sluit het venster en probeer het opnieuw.",
          "shares": "Geef elke regel een klant, een referentie, een factuur-e-mailadres en een aandeel in minstens één onderdeel.",
          "partiesUnavailable": "De partijen van een splitsing zijn klanten van de vergoedingsadministratie in WeFact, waar uw account geen toegang toe heeft. Vraag toegang tot de facturenmodule aan om ze te kunnen kiezen.",
          "overAllocated": "De aandelen en servicekosten overschrijden de locatieprijs voor: {{components}}."
        },
        "cancel": "Annuleren",
        "create": "Splitsing aanmaken",
        "save": "Wijzigingen opslaan"
      },
      "deleteDialog": {
        "title": "Splitsing verwijderen",
        "description": "Splitsing {{name}} verwijderen? Dit kan niet ongedaan worden gemaakt.",
        "confirm": "Splitsing verwijderen"
      },
      "toasts": {
        "created": "Splitsing {{name}} aangemaakt.",
        "updated": "Splitsing {{name}} bijgewerkt.",
        "deleted": "Splitsing {{name}} verwijderd.",
        "saveFailed": "Kon de splitsing niet opslaan. Probeer het opnieuw.",
        "deleteFailed": "Kon de splitsing niet verwijderen. Probeer het opnieuw."
      }
    }
  }
}
